import { Components, Theme } from '@mui/material/styles';

export default function Radio({ palette }: Theme): Components {
  return {
    MuiRadio: {
      styleOverrides: {
        root: {
          color: palette.primary.dark,
          '&.Mui-checked': {
            color: palette.primary.dark,
          },
        },
      },
    },
  };
}
